import { useState } from "react";

type FormStatus = "idle" | "sending" | "success" | "error";

export const useFormStatus = (resetDelay: number = 5000) => {
  const [status, setStatus] = useState<FormStatus>("idle");

  const setStatusWithReset = (newStatus: FormStatus) => {
    setStatus(newStatus);

    if (newStatus === "success" || newStatus === "error") {
      setTimeout(() => {
        setStatus("idle");
      }, resetDelay);
    }
  };

  const reset = () => setStatus("idle");

  return {
    status,
    setStatus: setStatusWithReset,
    reset,
    isLoading: status === "sending",
    isSuccess: status === "success",
    isError: status === "error",
    isIdle: status === "idle",
  };
};
